import { Input } from "../ui/input";
import type { Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { KeyboardEvent } from "react";
import { cn } from "@/lib/utils";

export default function FormInput<TFieldValues extends Record<string, unknown>>({
  form,
  label,
  id,
  description,
  className,
  itemStyles,
  fieldName,
  itemKey,
  afterElement,
  placeholder,
  autoFocus,
  afterLabel,
  onKeyDown,
}: {
  form: UseFormReturn<TFieldValues>;
  label: string;
  id: Path<TFieldValues>;
  description?: string;
  itemStyles?: string;
  className?: string;
  fieldName?: Path<TFieldValues>;
  itemKey?: string | number;
  afterElement?: React.ReactNode;
  placeholder?: string;
  autoFocus?: boolean;
  afterLabel?: React.ReactNode;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}) {
  return (
    <FormField
      key={itemKey}
      control={form.control}
      name={fieldName || id}
      render={({ field }) => (
        <FormItem className={itemStyles}>
          <FormLabel>
            <span className={`${afterLabel && "flex gap-2 items-center"}`}>
              {label}
              {afterLabel || ""}
            </span>
          </FormLabel>
          <FormControl className="w-full">
            <div
              className={`${afterElement && "flex gap-2 items-center justify-start"}`}
            >
              <Input
                {...field}
                value={field.value as string | number | readonly string[] | undefined}
                className={cn(className)}
                placeholder={placeholder}
                autoFocus={autoFocus}
                onKeyDown={onKeyDown}
              />
              {afterElement || null}
            </div>
          </FormControl>
          <FormDescription>{description}</FormDescription>
          <FormMessage className="text-xs ml-1 -mt-2" />
        </FormItem>
      )}
    />
  );
}
